module.exports = __webpack_public_path__ + "img/krystal_grand_2022.2f4d4299.jpg";